let _cd = require('lodash/cloneDeep')

export default {
  toNormalObject (vueObject) {
    return JSON.parse(JSON.stringify(vueObject))
  },

  cloneObject (object) {
    return _cd(object)
  }
}



// WEBPACK FOOTER //
// ./src/assets/modules/objectHelpers.js